import React from "react" 

export const CheckboxItem = ({index,item}) =>{
    const [checked,setChecked] = React.useState(false)
    React.useEffect(()=>{
        console.log('checked:', checked)
    },[checked])
    return (
        <li key={'checkbox-list-'+index}  >
            <label htmlFor={'checkbox'+index} >
            {/**  <input type="radio" name="workstyle" id={`r${i}`} /> **/}
                <div className="sb-checkbox" >
                    <input type="checkbox" checked={checked} onClick={()=>setChecked(!checked)}  className="sb-checkbox__input"  id={'checkbox'+index} name="" />
                    <label className="sb-checkbox__label sb-checkbox__label--green"  htmlFor={'checkbox'+index} ></label>
                </div>
                
                <div className="title" >{item.title}</div>
            </label>
        </li>
    )
}
